const getters = {
  allExaminations: (state) => state.examinations.data,
  allExaminationsPending: (state) => state.examinations.status.pending,
};

export default getters;
